import { useTranslation } from 'react-i18next';
import AppSubMenu from './AppSubMenu';
import { Paths } from '../../Common/Paths';
import { useAxios } from '../../Helpers/AxiosHelper';
import { ApiResponse, Items_EXT } from '../../Models/Classes';
import { useCallback, useEffect, useState } from 'react';
import { MenuModel } from './Index';
import { useToast } from '../../Helpers/ToastHelper';

const AppMenu = () => {
    const { t } = useTranslation();
    const AxiosHelper = useAxios();
    const { showToast } = useToast();
    const [menuItems, setMenuItems] = useState<MenuModel[]>([]);

    const transformJsonToMenuItems = useCallback((data: Items_EXT[]): MenuModel[] => {
        return data.map((item) => {
            const menuItem: MenuModel = {
                id: item.idItem as string,
                label: t(item.label),
                icon: item.icon || undefined,
                path: item.path ? Paths[item.path]?.value : undefined,  // Optional chaining to prevent errors
                items: item.items && item.items.length > 0 ? transformJsonToMenuItems(item.items) : [],  // Recursively process items
                url: item.path ? Paths[item.path]?.value : undefined
            };
            return menuItem;
        });
    }, [t]);

    useEffect(() => {
        const fetchBrand = async () => {
            try {
                const response = await AxiosHelper.get<ApiResponse<Items_EXT[]>>(`Menu/GetList`);
                const transformedMenuItems = transformJsonToMenuItems(response.data.data);
                setMenuItems(transformedMenuItems);  // Update state with transformed menu items
            } catch (error) {
                console.error('Error fetching menu data:', error);
                showToast('error', 'Error', t("Common.Toasts.Fetch.Error"));
            }
        };

        fetchBrand();
    }, [AxiosHelper, showToast, t, transformJsonToMenuItems]);

    return <AppSubMenu model={menuItems} />;  // Ensure that the component gets the correct model
};

export default AppMenu;
